import { Component, OnInit } from '@angular/core';

// import { default as billTypesObj } from './bill_types_sample.json';
import * as billTypesObj from "./bill_types_sample.json";
import { AppMetadataHandler } from 'app';

@Component({
  selector: 'app-ui-bill-details',
  templateUrl: './ui-bill-details.component.html',
  styleUrls: ['./ui-bill-details.component.scss']
})
export class UiBillDetailsComponent implements OnInit {

  billTypesAllowed:any = billTypesObj; 

  constructor(
    public appMetadataHandler: AppMetadataHandler
  ) { }

  ngOnInit() {
  }

  rows = [{id:1}];
  addRow() {
    let objDummy = {id:1};
    this.rows.push(objDummy);
  }
  removeRow(){
    this.rows.pop();
  }

  totalBillAmount: number = 10000;
  
  fileList = [
    { uid: 1, name: 'SCAN_001.jpg', status: 'done', response: 'SUCCESS', url: 'https://google.com' },
    { uid: 2, name: 'SCAN_002.jpg', status: 'done', url: 'https://google.com' },
  ];
}
